var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "progress-bars" }, [
    _c("div", { staticClass: "va-row" }, [
      _c("div", { staticClass: "flex md12 xs12" }, [_c("standard-bars")], 1),
    ]),
    _c("div", { staticClass: "va-row" }, [
      _c("div", { staticClass: "flex md12 xs12" }, [_c("colorful-bars")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }